export const isReady = state => state.video.isReady
export const hasError = state => state.video.hasError === true
export const getErrorMessage = state => state.video.errorMessage
export const getVideo = state => state.video.video
export const getVideoLoading = state => state.video.loading
